/**
 * @description 用于统一注册以 Au 开头的组件为全局组件
 * @created 2024/04/19 14:46:39
 * @author chenzy
 */

const requireComponents = require.context("@/components", true, /\.\/.+\/index\.vue?$/)

// 过滤掉非 Au 开头的组件
const components = requireComponents.keys().map((componentPath) => {
  const regexp = /^\.\/(.*?)\//
  return regexp.exec(componentPath)[1]
}).filter(item =>
  item.match(/^au/) || item.match(/^Au/)
)

const install = (Vue) => {
  // 批量配置全局组件
  components.forEach(componentName => {
    const componentConfig = requireComponents(`./${componentName}/index.vue`)
    Vue.component(componentName, componentConfig.default)
  })
}

export default install

